module.exports = __webpack_public_path__ + "static/img/white_animate1.7cc5e5c9.png";